import {
  Suspense,
  LazyExoticComponent,
  ComponentType,
  JSX,
  ReactNode,
  FC,
} from 'react';
import { LinearProgressProps } from '@mui/material/LinearProgress';
import Loader from 'ui-component/Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

interface LoaderProps extends LinearProgressProps {}

const Loadable =
  (
    Component:
      | LazyExoticComponent<() => JSX.Element>
      | ComponentType<ReactNode>
      | LazyExoticComponent<ComponentType<ReactNode>>
      | LazyExoticComponent<FC<any>>
      | LazyExoticComponent<FC>
  ) =>
  (props?: LoaderProps) =>
    (
      <Suspense fallback={<Loader />}>
        <Component {...(props || {})} />
      </Suspense>
    );

export default Loadable;
